// Port of api/fuel/app/classes/filter/package/games/play/data/games/players/group.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'
export default {
	require: function(config, filter) { return config.ownerType !== F.OWNER_USER && filter.play && filter.play.group },
	run: function(filter, data, config, global) {
		global.playerConfig = {}
		for (var i = 0; i < global.userIndex.length; i++) {
			global.playerConfig[global.userIndex[i]] = Config.user(global.userIndex[i])
		}

		var sql = 'SELECT pl.game_id AS g, pl.play_id AS p, pl.user_id AS u, pr.player_id AS pr, pr.user_id AS wu, pr.player_name AS wn, pl.play_count AS co FROM play pl LEFT JOIN player pr ON pl.play_id = pr.play_id AND pr.player_win = 1 WHERE pl.user_id IN(' + Util.in(global.userIndex) + ') AND pl.game_id IN(' + Util.in(global.resultIndex) + ') AND pl.play_result = 1'
		if (global.playContextIndex) sql += ' AND pl.play_id IN(' + Util.in(global.playContextIndex) + ')'
		global.players = Util.query(sql, false, 'g', true)
		return global
	}
}
